import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  LithiumMetalBatteriesContainedInEquipment,
  LithiumMetalBatteriesPackedWithEquipment,
  LithiumMetalBatteriesStandAlone,
  LithiumIonBatteriesContainedInEquipment,
  LithiumIonBatteriesPackedWithEquipment,
  LithiumIonBatteriesStandAlone,
  LimitedQuantity,
  SmallQuantityProvision,
} from '../../../../../../src/orders/other-shipping-options/constants/dhl-ecommerce/dangerous-goods-domestic';

import {
  LithiumMetalBatteriesContainedInEquipment as LithiumMetalBatteriesContainedInEquipmentIntl,
  LithiumMetalBatteriesPackedWithEquipment as LithiumMetalBatteriesPackedWithEquipmentIntl,
  LithiumMetalBatteriesStandAlone as LithiumMetalBatteriesStandAloneIntl,
  LithiumIonBatteriesContainedInEquipment as LithiumIonBatteriesContainedInEquipmentIntl,
  LithiumIonBatteriesPackedWithEquipment as LithiumIonBatteriesPackedWithEquipmentIntl,
  LithiumIonBatteriesStandAlone as LithiumIonBatteriesStandAloneIntl,
  LimitedQuantitiesCanadaOnly,
} from '../../../../../../src/orders/other-shipping-options/constants/dhl-ecommerce/dangerous-goods-international';
import messages from './messages';

const mapForMessages = {
  [LithiumMetalBatteriesContainedInEquipment]: <FormattedMessage {...messages.lithiumMetalBatteriesContainedInEquipment} />,
  [LithiumMetalBatteriesPackedWithEquipment]: <FormattedMessage {...messages.lithiumMetalBatteriesPackedWithEquipment} />,
  [LithiumMetalBatteriesStandAlone]: <FormattedMessage {...messages.lithiumMetalBatteriesStandAlone} />,
  [LithiumIonBatteriesContainedInEquipment]: <FormattedMessage {...messages.lithiumIonBatteriesContainedInEquipment} />,
  [LithiumIonBatteriesPackedWithEquipment]: <FormattedMessage {...messages.lithiumIonBatteriesPackedWithEquipment} />,
  [LithiumIonBatteriesStandAlone]: <FormattedMessage {...messages.lithiumIonBatteriesStandAlone} />,
  [LimitedQuantity]: <FormattedMessage {...messages.limitedQuantity} />,
  [SmallQuantityProvision]: <FormattedMessage {...messages.smallQuantityProvision} />,
  [LithiumMetalBatteriesContainedInEquipmentIntl]: <FormattedMessage {...messages.lithiumMetalBatteriesContainedInEquipment} />,
  [LithiumMetalBatteriesPackedWithEquipmentIntl]: <FormattedMessage {...messages.lithiumMetalBatteriesPackedWithEquipment} />,
  [LithiumMetalBatteriesStandAloneIntl]: <FormattedMessage {...messages.lithiumMetalBatteriesStandAlone} />,
  [LithiumIonBatteriesContainedInEquipmentIntl]: <FormattedMessage {...messages.lithiumIonBatteriesContainedInEquipment} />,
  [LithiumIonBatteriesPackedWithEquipmentIntl]: <FormattedMessage {...messages.lithiumIonBatteriesPackedWithEquipment} />,
  [LithiumIonBatteriesStandAloneIntl]: <FormattedMessage {...messages.lithiumIonBatteriesStandAlone} />,
  [LimitedQuantitiesCanadaOnly]: <FormattedMessage {...messages.limitedQuantitiesCanadaOnly} />,
};

export const getLabelForGoodsType = (goodsType) =>
  mapForMessages[goodsType] ?? <FormattedMessage {...messages.dhlDangerousGoodsNotDefined} />;
